import "../assets/styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer-distributed">
      <div className="footer-left">
        <h3>
          LittleChamp<span> Football Academy</span>
        </h3>
        <p className="footer-links">
          <a href="/">Home</a> | <a href="/">About</a> | <a href="/">Events</a>{" "}
          | <a href="/contact">Contact</a>
        </p>
        <p className="footer-company-name">
          Copyright &copy; {new Date().getFullYear()}{" "}
          <strong>Little Champ Football Academy</strong> All rights reserved{" "}
        </p>
      </div>
      <div className="footer-center">
        <div>
          <i className="fa fa-map-marker"></i>
          <p>
            <span>Senathipathipalayam</span>Erode
          </p>
        </div>
        <div>
          <i className="fa fa-phone"></i>
          <p>+91 99947 55567</p>
        </div>
        <div>
          <i className="fa fa-phone"></i>
          <p>+91 99527 84664</p>
        </div>
        <div className="fooemail">
          <i className="fa fa-envelope"></i>
          <p>
            <a href="mailto:littlechampfootballacademy@gmail.com?subject=Hello LittleChamp">
              littlechampfootballacademy @gmail.com
            </a>
          </p>
        </div>
      </div>
      <div className="footer-right">
        <p className="footer-company-about">
          <span>About the company</span>
          <strong>Little Champ</strong> is a football academy currently running
          with 60+ players at Senathipathipalayam in Erode. Leave your child
          with us to become a smashing player.
        </p>
        <div className="footer-icons">
          <a href="https://www.facebook.com/people/Little-Champ-Football-Academy-Erode/100086524118479/">
            <i className="fa fa-facebook-square"></i>
          </a>
          <a href="https://instagram.com/littlechampfootballacademy?igshid=MzRlODBiNWFlZA==">
            <i className="fa fa-instagram"></i>
          </a>

          <a href="https://wa.me/917868040150?text=Hello+Little+Champ%E2%9A%BD%2C%0D%0A">
            <i className="fa fa-whatsapp"></i>
          </a>
          <a href="https://www.youtube.com/@littlechampfootballacademy3630">
            <i className="fa fa-youtube"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
